var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RegistrationLayoutTitles',{attrs:{"title":_vm.$t('registration.contact_info.title', [_vm.firstName]),"subTitle":_vm.$t('registration.contact_info.description')}}),_c('ContactInfoForm',{attrs:{"onSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }